import { createContext } from 'react';

export interface Features {
  [key: string]: boolean;
}

export interface FeaturesContextType {
  features: Features;
  // Features are persisted in IndexedDB and hydrate asynchronously, so `features` is briefly empty
  // on every load and every flag reads as off. Consumers that only show or hide UI can ignore this;
  // anything that takes an irreversible action on a disabled flag (navigating away, redirecting)
  // must wait for it, or it will act on the empty snapshot instead of the user's real flags.
  areFeaturesReady: boolean;
  toggleFeature: (key: string) => void;
}

const FeaturesContext = createContext<FeaturesContextType>({
  features: {},
  // No provider above means nothing is pending; the empty feature set is already final.
  areFeaturesReady: true,
  toggleFeature: () => undefined,
});

export default FeaturesContext;
